export const spaceBetween = {
   display: 'flex',
   justifyContent: 'space-between',
   alignItems: 'center',
}
export const justifyCenter = {
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
}

export const bottomPosition = {
   position: 'absolute',
   left: '50%',
   bottom: '7%',
   transform: 'translateX(-50%)'
}

export const absoluteCenter = {
   position: 'fixed',
   left: '50%',
   top: '50%',
   transform: 'translate(-50%, -50%)'
}

export const customStyles = {
   colors: {
      main: '#2E6CD5',
      secondary:  '#3E86E2',
      red:  '#E20512',
      textColor: '#818181',
      lightColor: '#C3C9D2',
      backgroundColor: '#ffffff',
      success: '#53CB86',
      yellow: '#eded00'
      
   },
   fontSize: {
      small: 16,
      regular: 20,
      large: 30,
      xl: 40
   },
   containers: {
      large: 800,
      medium: 500,
      small: 300,
      full: '100%'
   },
   buttonSize: {
      small: 100,
      medium:  200,
      large: 350,
      full: '100%'
   },
   shadows: {
      light: '0 0 4px -1px #818181',
   }
}

export const PropsTextFunction = ( props ) => {
   return {
      color: props?.color,
      textAlign: props?.align,
      margin: '5px 0',
      textDecoration: props?.underline ? 'underline' : 'none',
      fontWeight: props?.bold && 700,
      ...props?.sx,
    }
}

export const addActiveClass = {
   '&:active': {
      transition: '.1s linear',
      // transform: 'scale(.97)'
   }
}

export const addHoverClass = {
   '&:hover': {
      transition: '.1s linear',
     outline: `4px solid ${customStyles.colors.secondary}`
   }
}